export enum RefreshTokenType {
  COOKIE = 'cookie',
  REQUEST_RESPONSE = 'response_body'
}
